// extracted by mini-css-extract-plugin
export default {"hideArrows":"KOMzlox12vJoKF13HKBT","placeHolderShimmer":"KO1Hz3tNllBKZN2kJ6ds"};